import { Formik } from "formik";
import { Fragment } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import FormDisplay from "./FormDisplay";
import {
  changePasswordObject,
  validationSchema,
  objectFromFormData,
} from "./changePasswordObjects";
import { useAxios, useAlert } from "../../../hooks";
import pages from "../../../constants/pages";

export default function Form({ code }) {
  const axios = useAxios();
  const { alert } = useAlert();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  return (
    <Fragment>
      <Formik
        enableReinitialize
        initialValues={changePasswordObject}
        validationSchema={validationSchema}
        validateOnMount
        onSubmit={(formData, { setSubmitting }) => {
          setSubmitting(true);
          axios({
            url: "/user/auth/resetPassword/" + code,
            method: "PUT",
            data: objectFromFormData(formData),
            disableRedirect: true,
          }).then((response) => {
            if (response.status) {
              dispatch(
                alert({
                  message: "Password changed successfully!",
                  type: "success",
                })
              );
              navigate(pages.signIn.route);
            }
            setSubmitting(false);
          });
        }}
      >
        {(formikProps) => <FormDisplay formikProps={formikProps} />}
      </Formik>
    </Fragment>
  );
}
